import React, { useState } from "react";
import useRestrictedAction from "../../../../hooks/useRestrictedAction";
import LargePopupRedirect from "../../../_utils/CommonPopups/CommonLargePopupRedirect";
import ICONS from "../../../../assets/Icons";
import FieldForceAccountViewAll from "../../../../containers/Accounts/FieldForceAccount/FieldForceAccountViewAll";
import ReimbursementAccountViewAll from "../../../../containers/Accounts/ReimbursementAccount/ReimbursementAccountViewAll";
import BeneficiaryAccountViewAll from "../../../../containers/Accounts/BeneficiaryAccount/BeneficiaryAccountViewAll";

const FieldForceAccountAssociatePopup = ({
  handleClick,
  handleCloseModal,
  createFieldForceAccountLoading,
  showModalPopup,
  accountNumber,
  ifsc,
  panNumber,
  setActiveType,
  setFieldForcePan,
  setFieldForceAccount,
  setFieldForceIFSC,
  fieldForceIFSC,
  fieldForceAccount,
  fieldForcePan,
  activeType,
  isBottomRequired,
  id,
}) => {
  const dropDownOptions = [
    "Field force account",
    "Beneficiary account",
    "Reimbursement account",
    "Tax account",
  ];
  const [currentAssociate, setCurrentAssociate] = useState(
    "Field force account",
  );

  const handleDropdownChange = (val) => {
    setActiveType("Pan");
    setFieldForcePan(panNumber);
    setFieldForceAccount("");
    setFieldForceIFSC("");
    setCurrentAssociate(val);
  };

  const handleCloseValue = () => {
    setActiveType("Pan");
    setFieldForcePan(panNumber);
    setFieldForceAccount("");
    setFieldForceIFSC("");
    setCurrentAssociate(dropDownOptions[0]);
  };

  const handleClosePopup = () => {
    setCurrentAssociate("Field force account");
    handleCloseModal();
  };

  const { showRestrictedAction } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction();
  };

  return (
    <LargePopupRedirect
      closeiconhandleFunction={handleClosePopup}
      isfullViewrequired={false}
      ispanbankRequired={true}
      isDropDownRequired={true}
      dropDownValue={currentAssociate}
      dropDownOptions={dropDownOptions}
      handleDropdownChange={handleDropdownChange}
      handleCloseValue={handleCloseValue}
      isDropDownDisabled={true}
      togglepan={() => {
        setActiveType("Pan");
        setFieldForcePan(panNumber);
        setFieldForceAccount("");
        setFieldForceIFSC("");
      }}
      toggleBank={() => {
        setActiveType("Bank");
        setFieldForcePan("");
        setFieldForceAccount(accountNumber);
        setFieldForceIFSC(ifsc);
      }}
      fullviewbtnText="Register a new account"
      redirectHeader="Register a new account"
      fullviewhandleFunction={() => {
        // handleClosePopup();
        // navigate("/beneficiary_account_dashboard/create_beneficiary_account");
      }}
      redirectIcon={ICONS?.ADD_BUTTON_WHITE}
      fullviewicon={ICONS?.REDIRECT}
      initialPanTab={activeType}
      headerTitle={
        isBottomRequired
          ? "Confirm creating this account?"
          : "Associate accounts"
      }
      headersubtext={
        !isBottomRequired &&
        "The accounts listed below are linked to the selected field force account. "
      }
      isbottomSectionneed={isBottomRequired}
      bottomHeaderTextNeed={true}
      bottomHeaderText={
        "On creating a new account, it gets added to the list of active accounts below as a 'pending' account for the PAN and Bank provided."
      }
      confirmbtnrequired={showModalPopup}
      btnText={"Create"}
      isDisabled={createFieldForceAccountLoading}
      isLoaderNeeded={true}
      isLoading={createFieldForceAccountLoading}
      enabledBgColor={"var(--positive-act)"}
      enabledTextColor={"var(--text-primary)"}
      disabledBgColor={
        createFieldForceAccountLoading
          ? "var(--positive-act)"
          : "var(--text-disabled)"
      }
      disabledTextColor={"var(--text-primary)"}
      outLineColor={""}
      hoverOption={"dark"}
      handleFunction={handleClick}
    >
      {currentAssociate === "Field force account" ? (
        <FieldForceAccountViewAll
          type={"fieldForceAccount"}
          fieldForcePan={fieldForcePan}
          fieldForceIFSC={fieldForceIFSC}
          fieldForceAccountNo={fieldForceAccount}
          classifiedFlow={true}
          handleClosePopup={handleClosePopup}
          id={id}
        />
      ) : currentAssociate === "Reimbursement account" ? (
        <ReimbursementAccountViewAll
          type={"ReimbursementAcc"}
          remPan={fieldForcePan}
          remAccount={fieldForceAccount}
          remIFSC={fieldForceIFSC}
          mainType={"create"}
          classifiedFlow={true}
        />
      ) : (
        <BeneficiaryAccountViewAll
          typepop={"popup"}
          alertPop={"AlertPopAsso"}
          handleClick={handleClick}
          showModalPopup={showModalPopup}
          associateAccount={"associateTxn"}
          remPan={fieldForcePan}
          remAccount={fieldForceAccount}
          classifiedFlow={true}
          remIFSC={fieldForceIFSC}
          handleButtonClick={() => {
            actionRestricted();
          }}
        />
      )}
    </LargePopupRedirect>
  );
};

export default FieldForceAccountAssociatePopup;
